import * as React from 'react'

import * as styles from './imagePlaceholder.module.css'

interface IProps {
  ratio?: number
  className?: string
  children?: any
  width?: number
  height?: number
}

const ImagePlaceholder = ({
  ratio = 1,
  width,
  height,
  className = '',
  children
}: IProps) => (
  <div
    className={`${styles.root} ${className}`}
    style={{ paddingTop: `${ratio * 100}%`, width, height }}
  >
    {children}
  </div>
)

export default ImagePlaceholder
